module.exports = __webpack_public_path__ + "d6c9ee803832dbca2450d5c0d59b3d60.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-8.png
// module id = 2201
// module chunks = 0